import React from "react";
import { formatMatchMinutes } from "../../../mls-match-summary/utils";
import StatusStamp from "../../../shared/components/StatusStamp/StatusStamp";
import { useMatchData } from "../../utils";
import { StyledMatchTime } from "./StyledMatchTime";

export const MatchTime = ({ abbreviateStatus }) => {
  const { matchDateTime, status, minuteDisplay } = useMatchData();
  const { date } = matchDateTime || {};
  const time = date;
  const [minutes, extraMinutes] = formatMatchMinutes(minuteDisplay);

  return (
    <StyledMatchTime className="mls-c-match-list__strip-time">
      <StatusStamp
        time={time}
        minuteDisplay={minutes}
        extraMinutes={extraMinutes}
        date={date}
        abbreviation={status?.abbreviation}
        abbreviateStatus={abbreviateStatus}
      />
    </StyledMatchTime>
  );
};
